import type { ItemRenderer } from "./types";

export const renderRail: ItemRenderer = ({ svg, bboxPx }) => {
    const color = "#a64022";

    const frameStroke = 0.45;
    const frame = {
        x: bboxPx.x + frameStroke / 2,
        y: bboxPx.y + frameStroke / 2,
        w: Math.max(0, bboxPx.w - frameStroke),
        h: Math.max(0, bboxPx.h - frameStroke),
    };

    svg.rect(frame.w, frame.h).move(frame.x, frame.y).fill("none").stroke({ width: frameStroke, color });

    const stripeStroke = 0.6;
    const yStripe = frame.y + frame.h / 3;
    const x1 = frame.x + frameStroke / 2;
    const x2 = frame.x + frame.w - frameStroke / 2;

    svg.line(x1, yStripe, x2, yStripe).stroke({ width: stripeStroke, color, linecap: "butt" });
};
